export enum Rounds{
    DELETESTUDENTS = 'Remove Students',
    ADDSTUDENTS = 'Add Students',
    ADD = 'Add',
    REMOVE = 'Remove',
    ADDSTUDENTMANUALLY = 'Add Students Manually',
    REMOVESTUDENTMANUALLY = 'Remove Students Manually',
    EMAILIDS = 'Email IDs',
    ADDUSING = 'Add Using',
    ADDVIA = 'Add Via',
    PROFILEDESIGNATION = 'Add Profile/Designation',
    SELECTPROFILEDESIG = 'Select Profile/Designation'
}

export const addRemoveStudents = [
    { label: 'Add Students', value: 'addStudents' },
    { label: 'Remove Students', value: 'removeStudents' },
]